window.onload = () => {
    // Verifica se a URL contém "?customer_posted=true#contact_form"
    if (window.location.search.includes("customer_posted=true") && window.location.hash === "#contact_form") {
        const successMessage = document.querySelector(".newsletter-form__message--success");

        if (successMessage) {
            // Aguarda 4 segundos e esconde a mensagem da Newsletter no Rodapé
            setTimeout(() => {
                successMessage.style.display = "none";
            }, 4000);
        }
    }
};


function initializeQuantityInputs() {
    const interval = setInterval(() => {
        const inputs = document.querySelectorAll('.quantity__input[type=number]');
        console.log("Elementos encontrados:", inputs);

        inputs.forEach(input => {
            if (!input.hasAttribute('data-initialized')) { // Evita duplicar eventos
                input.setAttribute('data-initialized', 'true'); // Marca como inicializado
                input.setAttribute('pattern', '\\d+');
                input.addEventListener('input', function () {
                    this.value = this.value.replace(/[^0-9]/g, ''); // Permite apenas números
                });
            }
        });

        // Verifica se todos os elementos foram inicializados
        if (inputs.length > 0 && Array.from(inputs).every(input => input.hasAttribute('data-initialized'))) {
            clearInterval(interval); 
        }
    }, 500);
}


if(document.querySelector(".product-form__input") != null) {
  initializeQuantityInputs();
}


